import { shouldPolyfill as shouldPolyfillPluralrules } from '@formatjs/intl-pluralrules/should-polyfill';
import { shouldPolyfill as shouldPolyfillLocale } from '@formatjs/intl-locale/should-polyfill';
import { shouldPolyfill as shouldPolyfillNumberFormat } from '@formatjs/intl-numberformat/should-polyfill';
import { getKnownLanguages } from './js/common/utils';

async function polyfillLocale() {
  if (shouldPolyfillLocale()) {
    await import('@formatjs/intl-locale/polyfill');
  }
}

async function polyfillPluralrules(locale: string) {
  const unsupportedLocale = shouldPolyfillPluralrules(locale);
  if (!unsupportedLocale) {
    return;
  }
  await import('@formatjs/intl-pluralrules/polyfill-force');
  const polyfills: Record<string, () => void> = {
    en: () => import(`@formatjs/intl-pluralrules/locale-data/en`),
    es: () => import(`@formatjs/intl-pluralrules/locale-data/es`),
    pt: () => import(`@formatjs/intl-pluralrules/locale-data/pt`),
  };

  await polyfills[locale]();
}

async function polyfillNumberFormat(locale: string) {
  const unsupportedLocale = shouldPolyfillNumberFormat(locale);
  if (!unsupportedLocale) {
    return;
  }
  await import('@formatjs/intl-numberformat/polyfill-force');

  const polyfills: Record<string, () => void> = {
    en: () => import(`@formatjs/intl-numberformat/locale-data/en`),
    es: () => import(`@formatjs/intl-numberformat/locale-data/es`),
    pt: () => import(`@formatjs/intl-numberformat/locale-data/pt`),

  };

  await polyfills[locale]();
}

export async function polyfillLocales() {
  return polyfillLocale()
    .then(() =>
      Promise.all(getKnownLanguages().map((lang) => polyfillPluralrules(lang))),
    )
    .then(() =>
      Promise.all(
        getKnownLanguages().map((lang) => polyfillNumberFormat(lang)),
      ),
    );
}
